import React, { FC } from 'react';
import { Alert, AlertTitle, Box, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';
import { ExpectedErrorFeedback } from 'components/shared/denthub-error-boundary/expected-graphql-errors';

type OrderUnavailableProps = {
    feedback: ExpectedErrorFeedback;
};

/**
 * DD-3791: the order page when the backend refuses the order (not found, no access, or an
 * external technician the lab has not added to it). It replaces the loader, which otherwise
 * spun forever behind the feedback dialog, and leads back to the user's own order list.
 */
const OrderUnavailable: FC<OrderUnavailableProps> = ({ feedback }) => {
    const { t: translate } = useTranslation(['errors', 'common']);

    return (
        <Box maxWidth={700} mx="auto" mt={4} data-test="order-details.unavailable">
            <Alert severity="info">
                <AlertTitle>{translate(`errors:${feedback.translationTitleKey}`)}</AlertTitle>
                <Box mb={2}>{translate(`errors:${feedback.translationMessageKey}`)}</Box>
                <Button
                    component={NavLink}
                    variant="contained"
                    to="/orders/list"
                    data-test="order-details.unavailable.back-to-orders"
                >
                    {translate('common:BACK_TO_ORDER_LIST')}
                </Button>
            </Alert>
        </Box>
    );
};

export default OrderUnavailable;
